import navStyles from './CaseNav.module.css';

import { CaseReport, CaseReportSummary } from '../models/CaseTypes';
import { formatCaseDateDisplay } from '../utils/caseUtils';

interface CaseListProps {
  cases: CaseReportSummary[]|null;
  error: string | null;
  onCaseSelect: (caseReport: CaseReportSummary) => void;
  onReload: () => void;
  onSortCases: (field: string) => void;
  selectedCase?: CaseReport | null;
  sortField?: string;
  sortDirection?: string;
}

const CaseList = (
  { cases, error, onCaseSelect, onReload, onSortCases, selectedCase, sortField, sortDirection }: CaseListProps
): React.JSX.Element  => {

  return (
    <div className={navStyles['case-history-sidebar']}>
      <div className={navStyles['case-history-header']}>
        <h3 className={navStyles['case-history-title']}>Case History</h3>
        <p className={navStyles['case-history-description']}>
          Choose a case from your history to view the related case performance report.
        </p>
      </div>

      {/* Column Headers */}
      <div className={navStyles['case-list-column-headers']}>
        <div className={navStyles['case-column']}>
          <div
            className={navStyles['column-header-text']}
            onClick={() => onSortCases('name')}
          >
            Case Name {sortField === 'name' && (sortDirection === 'asc' ? '▲' : '▼')}
          </div>
        </div>
        <div className={navStyles['date-column']}>
          <div
            className={navStyles['column-header-text']}
            onClick={() => onSortCases('date')}
          >
            Date {sortField === 'date' && (sortDirection === 'asc' ? '▲' : '▼')}
          </div>
        </div>
        <div className={navStyles['levels-column']}>
          <div
            className={navStyles['column-header-text']}
            onClick={() => onSortCases('levels')}
          >
            Levels {sortField === 'levels' && (sortDirection === 'asc' ? '▲' : '▼')}
          </div>
        </div>
      </div>

      {/* Case List */}
      <div className={navStyles['case-list']}>
        {error && (
          <div className="error-message">
            {error}
            <button
              onClick={onReload}
              style={{
                marginLeft: '10px',
                padding: '2px 5px',
                background: '#6c757d',
                border: 'none',
                color: 'white',
                cursor: 'pointer',
                borderRadius: '3px',
                fontSize: '12px'
              }}
            >
              Retry
            </button>
          </div>
        )}

        {cases === null || cases.length === 0 ? (
          <div className="empty-state">No cases found</div>
        ) : (
          cases.map(caseItem => (
            <div
              key={caseItem.id}
              className={`${navStyles['case-item']} ${selectedCase && selectedCase.id === caseItem.id ? navStyles['case-item-selected'] : ''}`}
              onClick={async () => onCaseSelect(caseItem)}
            >
              {selectedCase && selectedCase.id === caseItem.id && (
                <div className={navStyles['case-item-indicator']}></div>
              )}
              <div className={navStyles['case-name-cell']}>
                <div className={navStyles['case-cell-content']}>
                  <span className={navStyles['case-name-text']}>{caseItem.name}</span>
                </div>
              </div>
              <div className={navStyles['case-date-cell']}>
                <div className={navStyles['case-cell-content']}>
                  <span className={navStyles['case-date-text']}>{formatCaseDateDisplay(caseItem.date)}</span>
                </div>
              </div>
              <div className={navStyles['case-level-cell']}>
                <div className={navStyles['case-cell-content']}>
                  <span className={navStyles['case-level-text']}>{caseItem.levels || '-'}</span>
                </div>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );

};

export default CaseList;
